import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { DealDetailsDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { DealUpdateModal } from 'modules/finance/components/Deals/UpdateModal'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import OverviewInformation from './Overview'

const DealDetailsPage = () => {
  const { dealId } = useParams()
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false)

  const { data, loading, error } = useQuery(DealDetailsDocument, {
    variables: {
      id: Number(dealId),
    },
  })
  const deal = data?.finance?.deal

  const canSeeDeals = data?.finance._policies.sidebarSeeFinanceDealsSubLevelItem.can ?? false

  useEffect(() => {
    track(trackingEvents.accounting.deals.viewDealDetails)
  }, [])

  const handleOpenModal = (element: string) => {
    setIsUpdateModalOpen(true)
    track(trackingEvents.accounting.deals.startEdit, {
      source: 'sales_deal_details_page',
      element: element,
    })
  }

  const handleDealUpdated = () => {
    track(trackingEvents.accounting.deals.submitEdit, {
      source: 'sales_deal_details_page',
    })
  }

  return (
    <ResponsivePage.Body
      authorized={canSeeDeals && !!deal}
      error={error}
      loading={loading}
      variant="full"
      onActionClick={(key) => {
        switch (key) {
          case 'edit-deal':
            handleOpenModal('header_edit-deal')
            break
          default:
            break
        }
      }}
    >
      {deal && (
        <>
          <OverviewInformation
            deal={deal}
            onOpenUpdateModal={() => handleOpenModal('overview_edit-deal')}
          />
          <DealUpdateModal
            isOpen={isUpdateModalOpen}
            onClose={() => setIsUpdateModalOpen(false)}
            deal={deal}
            onSuccess={handleDealUpdated}
          />
        </>
      )}
    </ResponsivePage.Body>
  )
}

export default DealDetailsPage
